var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrvsArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90848 0.237154C10.0666 0.395257 10.1456 0.582451 10.1456 0.798736C10.1456 1.0146 10.0666 1.20158 9.90848 1.35968L5.27606 5.99209L9.92429 10.6403C10.0718 10.7879 10.1456 10.9723 10.1456 11.1937C10.1456 11.415 10.0666 11.6047 9.90848 11.7628C9.75037 11.9209 9.56318 12 9.34689 12C9.13103 12 8.94405 11.9209 8.78595 11.7628L3.47369 6.43478C3.41045 6.37154 3.36555 6.30303 3.33899 6.22925C3.31285 6.15547 3.29978 6.07642 3.29978 5.99209C3.29978 5.90777 3.31285 5.82872 3.33899 5.75494C3.36555 5.68116 3.41045 5.61265 3.47369 5.54941L8.80176 0.221344C8.94932 0.073781 9.13103 0 9.34689 0C9.56318 0 9.75037 0.079051 9.90848 0.237154Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrvsArrowDark);
export default __webpack_public_path__ + "static/media/prvsArrow_dark.445eafab6f37e5b707bbd640e14e847a.svg";
export { ForwardRef as ReactComponent };